    import { ref, computed, watch } from 'vue'

    import { defineStore, acceptHMRUpdate } from 'pinia'
    import { useRoute } from 'vue-router'

    export const useViewStore = defineStore('view', () => {

        const scrollDist = ref(0)
        const parentScrollDist = ref(0)

        const pageNavTitle = ref(null)
        const pageNavItems = ref([])

        const isEmbedded = ref(false)

        const lastNavSelected = ref(null)

        // Tour state
        const tourSteps = ref([])
        const tourActive = ref(false)
        const tourOnFinish = ref(null)

        const route = useRoute()

        const footerHiddenRoutes = [
            'search.caregivers',
        ]

        const shouldShowFooter = computed(() => {
            return !isEmbedded.value && !footerHiddenRoutes.some(r => route.name?.startsWith(r))
        })

        //
        // View helpers
        //

        function pageNavLoad(title, items) {
            pageNavTitle.value = title
            pageNavItems.value = items.value || items
        }

        function pageNavUnload() {
            pageNavTitle.value = null
            pageNavItems.value = []
        }

        function clickNavItem(item) {
            lastNavSelected.value = item
            setTimeout(() => {
                lastNavSelected.value = null
            }, 200)
        }

        function handleParentScroll(message) {
            if (message.scrollDist >= message.iframeOffsetTop) {
                parentScrollDist.value = message.scrollDist - message.iframeOffsetTop
            } else {
                parentScrollDist.value = 0
            }
        }


        //
        // Tour helpers
        //

        const tourStart = ref(null)
        const tourFinish = ref(null)
        const tourGoToStep = ref(null)

        function startTour(steps, onFinish = null, startIndex = 0) {
            tourSteps.value = steps.map((step, index) => ({
                ...step,
                options: {
                    ...step.options,
                    stepIndex: index + 1,
                    totalSteps: steps.length,
                },
            }))
            tourOnFinish.value = onFinish
            tourActive.value = true
            if (tourStart.value) {
                tourStart.value()
            }
            if (tourGoToStep.value && tourSteps.value.length > 0) {
                tourGoToStep.value(startIndex)
            }
        }

        function finishTour() {
            tourActive.value = false
            if (tourOnFinish.value && typeof tourOnFinish.value === 'function') {
                tourOnFinish.value()
            }
            tourSteps.value = []
            tourOnFinish.value = null
            if (tourFinish.value) {
                tourFinish.value()
            }
        }


        watch(isEmbedded, () => {
            if (isEmbedded.value) {
                document.body.classList.add('bg-[#EDEDED]')
                document.body.classList.remove('bg-lifeworx-alabaster')
            }
        })


        return {
            scrollDist, parentScrollDist, isEmbedded,
            pageNavTitle, pageNavItems,
            tourSteps, tourActive,
            handleParentScroll, pageNavLoad, pageNavUnload, clickNavItem, lastNavSelected,
            tourStart, tourFinish, tourGoToStep,
            startTour, finishTour,
            shouldShowFooter
        }

    })

    if (import.meta.hot) {
        import.meta.hot.accept(acceptHMRUpdate(useViewStore, import.meta.hot))
    }
